<template>
<div class="not-found f ai-c jc-c">
  <img src="../assets/404.png" alt="">
</div>
</template>

<script>
export default {
  name: "errorPage"
}
</script>

<style lang="scss" scoped>
.not-found{
  width: 100%;
  height: 100%;
}
</style>